<template>
  <modal name="login" :height="'auto'" :width="'375'">
    <auth
      :title="channel.name"
      :description="`Sign Up for ${channel.name}—${channel.description}`"
      @callback="handleCallback"
      :terms="true"
    />
  </modal>
</template>

<script>
import Auth from '../_Shared/Auth'
import { mapState } from 'vuex'
import analytics from '../../mixins/analytics'

export default {
  name: 'ChannelLogin',
  components: {
    'auth': Auth
  },
  mixins: [
    analytics
  ],
  props: {
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['channel', 'user'])
  },
  methods: {
    handleCallback (data) {
      this.track('[Channel] Sign In')
      if (!data.exists) {
        return this.$router.push({name: 'channel-sign-up'})
      }
      return this.$router.push({name: 'channel-landing'})
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";
</style>
